import React from 'react'
import { PROJECT_RUBRICS, PROJECT_STATUSES, DEPARTMENTS } from './constants'

export function renderProjects(ctx) {
  const {
    activeProject,
    activeTab,
    activeWorkersList,
    adminCommentText,
    handleAddProject,
    handleAdminComment,
    handleDeleteProject,
    handleProjectStatusChange,
    projectForm,
    projectStatus,
    projects,
    setActiveProject,
    setAdminCommentText,
    setProjectForm,
    t,
    workers,
  } = ctx
  return (
    <>
          {activeTab === 'projects' && !activeProject && (
            <div className="dash-section">
              <div className="dash-section-header"><h2>{t.projectManagement}</h2><p>{t.createProjects}</p></div>

              <div className="dash-form-card">
                <h3>{t.createNewProject}</h3>
                <form className="dash-form" onSubmit={handleAddProject}>
                  <div className="dash-form-row">
                    <label>{t.projectTitle} <span className="dash-required">*</span><input type="text" value={projectForm.title} onChange={e => setProjectForm(p => ({ ...p, title: e.target.value }))} placeholder="Road Infrastructure Phase 1" /></label>
                    <label>{t.rubricCategory}
                      <select value={projectForm.rubric} onChange={e => setProjectForm(p => ({ ...p, rubric: e.target.value }))}>
                        {PROJECT_RUBRICS.map(r => <option key={r} value={r}>{r}</option>)}
                      </select>
                    </label>
                  </div>
                  <div className="dash-form-row">
                    <label>{t.startDate}<input type="date" value={projectForm.startDate} onChange={e => setProjectForm(p => ({ ...p, startDate: e.target.value }))} /></label>
                    <label>{t.dueDate}<input type="date" value={projectForm.dueDate} onChange={e => setProjectForm(p => ({ ...p, dueDate: e.target.value }))} /></label>
                  </div>
                  <div className="dash-form-row">
                    <label>{t.assignToWorker}
                      <select value={projectForm.assignedTo} onChange={e => setProjectForm(p => ({ ...p, assignedTo: e.target.value }))}>
                        <option value="">{t.selectWorker}</option>
                        {activeWorkersList.map(w => <option key={w.id} value={w.id}>{w.name} ({DEPARTMENTS.find(d => d.value === w.department)?.label || w.department})</option>)}
                      </select>
                    </label>
                    <label>{t.initialStatus}
                      <select value={projectForm.status} onChange={e => setProjectForm(p => ({ ...p, status: e.target.value }))}>
                        {PROJECT_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </label>
                  </div>
                  <label>{t.description} <span className="dash-required">*</span><textarea rows="3" value={projectForm.description} onChange={e => setProjectForm(p => ({ ...p, description: e.target.value }))} placeholder="Describe the project scope and objectives..." /></label>
                  <div className="dash-form-actions">
                    <button className="dash-btn primary" type="submit">{t.createProject}</button>
                    {projectStatus && <span className="dash-status-msg">{projectStatus}</span>}
                  </div>
                </form>
              </div>

              {projects.length === 0 ? (
                <div className="dash-empty-state"><span>📋</span><p>{t.noProjects}</p></div>
              ) : (
                <div className="dash-projects-grid">
                  {projects.map(p => {
                    const manager = workers.find(w => w.id === p.assignedTo)
                    return (
                      <div key={p.id} className="dash-project-card">
                        <div className="dash-project-card-header">
                          <span className={`dash-cat-badge ${p.rubric.toLowerCase()}`}>{p.rubric}</span>
                          <button className="dash-delete-icon" onClick={() => handleDeleteProject(p.id)}>×</button>
                        </div>
                        <h4 className="dash-project-title">{p.title}</h4>
                        <p className="dash-project-desc">{p.description}</p>
                        <div className="dash-project-progress-row">
                          <span>{p.progress}%</span>
                          <div className="dash-progress-bar"><div className="dash-progress-fill" style={{ width: `${p.progress}%` }} /></div>
                        </div>
                        <div className="dash-project-meta">
                          {manager && <span>👤 {manager.name}</span>}
                          {p.dueDate && <span>📅 {new Date(p.dueDate).toLocaleDateString()}</span>}
                          <span>🔄 {p.updates?.length || 0} updates</span>
                        </div>
                        <div className="dash-project-footer">
                          <select className="dash-status-select-sm" value={p.status} onChange={e => handleProjectStatusChange(p.id, e.target.value)}>
                            {PROJECT_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                          <button className="dash-btn secondary small" onClick={() => setActiveProject(p)}>{t.viewUpdates}</button>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )}

          {activeTab === 'projects' && activeProject && (() => {
            const proj = projects.find(p => p.id === activeProject.id) || activeProject
            const assignedWorker = workers.find(w => w.id === proj.assignedTo)
            const allComments = [...(proj.comments || [])].sort((a, b) => new Date(a.at) - new Date(b.at))
            return (
              <div className="dash-section">
                <button className="dash-back-btn" onClick={() => setActiveProject(null)}>{t.backToProjects}</button>
                <div className="dash-section-header">
                  <h2>{proj.title}</h2>
                  <p>{proj.description}</p>
                </div>
                <div className="dash-project-detail-grid">
                  <div className="dash-project-detail-left">
                    {/* Info card */}
                    <div className="dash-detail-card">
                      <h3>Project Info</h3>
                      <div className="dash-detail-row"><span>{t.rubric}</span><span className={`dash-cat-badge ${proj.rubric.toLowerCase()}`}>{proj.rubric}</span></div>
                      <div className="dash-detail-row"><span>{t.status}</span>
                        <select className="dash-status-select-sm" value={proj.status} onChange={e => handleProjectStatusChange(proj.id, e.target.value)}>
                          {PROJECT_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                      <div className="dash-detail-row"><span>{t.assignedTo}</span>
                        <div className="dash-worker-chip">
                          {assignedWorker?.avatar ? <img src={assignedWorker.avatar} alt="" className="dash-worker-chip-avatar" /> : <span className="dash-worker-chip-init">{assignedWorker?.name[0]?.toUpperCase() || '?'}</span>}
                          <span>{assignedWorker?.name || '—'}</span>
                        </div>
                      </div>
                      <div className="dash-detail-row"><span>{t.start}</span><span>{proj.startDate ? new Date(proj.startDate).toLocaleDateString() : '—'}</span></div>
                      <div className="dash-detail-row"><span>{t.due}</span><span>{proj.dueDate ? new Date(proj.dueDate).toLocaleDateString() : '—'}</span></div>
                      <div className="dash-detail-row"><span>{t.progressUpdates}</span><strong>{proj.progress}%</strong></div>
                      <div className="dash-progress-bar large"><div className="dash-progress-fill" style={{ width: `${proj.progress}%` }} /></div>
                    </div>

                    {/* Updates timeline */}
                    <div className="dash-detail-card">
                      <h3>{t.progressUpdates} ({proj.updates?.length || 0})</h3>
                      <div className="dash-updates-timeline">
                        {(proj.updates || []).length === 0 ? (
                          <p className="dash-empty-msg">{t.noUpdatesYet}</p>
                        ) : (
                          [...(proj.updates || [])].reverse().map(u => (
                            <div key={u.id} className="dash-update-item">
                              <div className="dash-update-dot" />
                              <div className="dash-update-body">
                                <div className="dash-update-header">
                                  <strong>{u.by || u.workerName}</strong>
                                  <span className="dash-update-time">{new Date(u.at || u.timestamp).toLocaleString()}</span>
                                  <span className="dash-update-progress">{u.progress}%</span>
                                </div>
                                <p>{u.note}</p>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Comments panel */}
                  <div className="dash-comments-panel">
                    <h3>{t.commentsSection} ({allComments.length})</h3>
                    <div className="dash-comments-list">
                      {allComments.length === 0 ? (
                        <p className="dash-empty-msg">{t.noComments}</p>
                      ) : (
                        allComments.map(c => (
                          <div key={c.id} className={`dash-comment ${c.role}`}>
                            <div className="dash-comment-header">
                              <span className="dash-comment-author">{c.by}</span>
                              <span className={`dash-comment-role-badge ${c.role}`}>{c.role}</span>
                              <span className="dash-comment-time">{new Date(c.at).toLocaleString()}</span>
                            </div>
                            <p className="dash-comment-text">{c.text}</p>
                          </div>
                        ))
                      )}
                    </div>
                    <form className="dash-comment-form" onSubmit={handleAdminComment}>
                      <textarea
                        className="dash-comment-input"
                        value={adminCommentText}
                        onChange={e => setAdminCommentText(e.target.value)}
                        placeholder={t.writeAComment}
                        rows={3}
                        required
                      />
                      <button className="dash-btn primary small" type="submit">{t.postComment}</button>
                    </form>
                  </div>
                </div>
              </div>
            )
          })()}

    </>
  )
}
